import { render, staticRenderFns } from "./OnboardingNotification.vue?vue&type=template&id=047c1766&scoped=true&"
import script from "./OnboardingNotification.vue?vue&type=script&lang=ts&"
export * from "./OnboardingNotification.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingNotification.vue?vue&type=style&index=0&id=047c1766&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c1766",
  null
  
)

export default component.exports